import { render, staticRenderFns } from "./BjMonograph.vue?vue&type=template&id=4baa6369&scoped=true"
import script from "./BjMonograph.vue?vue&type=script&lang=js"
export * from "./BjMonograph.vue?vue&type=script&lang=js"
import style0 from "./BjMonograph.vue?vue&type=style&index=0&id=4baa6369&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4baa6369",
  null
  
)

export default component.exports